import { Box } from '@mui/system';
import { RichTextInput } from 'ra-input-rich-text';
import * as React from 'react';
import {
  Create,
  SimpleForm,
  ReferenceInput,
  SelectInput,
  TextInput,
  required,
  ImageInput,
  BooleanInput,
  NumberInput,
  DateInput,
  DateTimeInput,
  ImageField,
} from 'react-admin';

export default function ResourceCreate(props: any) {
  return (
    <Box sx={styles.boxStyle}>
      <Create sx={styles.createStyle} {...props}>
        <SimpleForm style={styles.inputStyle}>
          <ReferenceInput
            label={'Language'}
            source='languageId'
            reference='language'
          >
            <SelectInput optionText='name' sx={styles.inputStyle} />
          </ReferenceInput>
          <ReferenceInput
            label={'Category'}
            source='categoryId'
            reference='category'
          >
            <SelectInput optionText='name' />
          </ReferenceInput>

          <ReferenceInput
            label={'Product'}
            source='productId'
            reference='product'
          >
            <SelectInput optionText='name' />
          </ReferenceInput>
          <TextInput source='key' sx={styles.inputStyle} />
          <TextInput source='value' sx={styles.inputStyle} />
        </SimpleForm>
      </Create>
    </Box>
  );
}

const styles = {
  boxStyle: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  createStyle: {
    width: '50%',
    minWidth: 250,
  },
  inputStyle: {
    width: '100%',
  },
};
